export const LOADING_DATA = 'loading/LOADING_DATA'
export const LOADING_ONLINE = 'online/LOADING_ONLINE'
